import { parseNumber } from "../services/currencyService";

/**
 * תצוגת מחיר בשקלים בלבד — ללא currentRate / המרת מטבע / default-currency.
 * לשימוש כאשר הערך כבר ב-ILS (אחרי usdToIls / resolveHotelSellingDisplay / calcBaseCommission על בסיס ILS וכו׳).
 *
 * @param {unknown} value
 * @returns {string}
 */
export function formatIlsDisplay(value) {
  if (value === null || value === undefined || value === "") {
    return "—";
  }
  const n = typeof value === "number" ? value : parseFloat(value);
  if (!Number.isFinite(n)) {
    return "—";
  }
  return `${parseNumber(n)}₪`;
}
